import * as _4 from 'lodash4';
import { ResourceCategory } from '../builders/resource_category_builder';
import { IResourceDetail } from '../builders/resource_detail_builder';
import { ResourceListQuery } from '../queries/resource_list_query';

export class ResourceListServant {
  constructor(private ngResourceListQuery: ResourceListQuery) {}

  getResourceForCategory(id: number): IResourceDetail[] {
    return _4.sortBy(
      _4.filter(
        this.ngResourceListQuery.result,
        (resourceDetail: IResourceDetail) => (resourceDetail.resource_category as ResourceCategory).id === id
      ),
      (detail: IResourceDetail) => detail.name.toLowerCase()
    );
  }

  getResource(id: number): IResourceDetail {
    return _4.find(this.ngResourceListQuery.result, (resourceDetail: IResourceDetail) => resourceDetail.id === id);
  }

  getFavoriteResources(): IResourceDetail[] {
    return _4.filter(this.ngResourceListQuery.result, (resourceDetail: IResourceDetail) =>
      _4.isNumber(resourceDetail.favorite_id)
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/servants/resource_list_servant.ts